// @flow

import { combineEpics } from 'redux-observable';

import coreEpic from '../core/epics';
import authenticationEpic from '../authentication/epics';
import timeClockEpic from '../timeClock/epics';
import shiftTasksEpic from '../shiftTasks/epics';

export default combineEpics(coreEpic, authenticationEpic, timeClockEpic, shiftTasksEpic);
